import React from "react";
import { isSystemModuleActive } from "../../../helpers/functions/systemModules";
import ModuleNotActive from "../ModuleNotActive";

// Route/section guard for feature-gated SystemModules.
//
// Renders `children` when the module `code` is active, otherwise shows the
// ModuleNotActive page (with a link to Settings > Modules). Use it to gate a
// whole route so deep links to a disabled feature land somewhere sensible
// instead of an empty/broken screen.
const ModuleGate = ({ code, moduleName, description, children }) => {
  if (isSystemModuleActive(code)) return children;
  return <ModuleNotActive moduleName={moduleName} description={description} />;
};

export default ModuleGate;
